
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources05 as ObiSources05Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-05.js';
 
 
 

 
 export const ObiSources05 = createComponent({
   react: React,
   tagName: 'obi-sources-05',
   elementClass: ObiSources05Element,
   events: {
     
   }
  });
 
 